import { AxiosResponse } from 'axios';
import { game, gameDetail, selection, selectionDetail } from '@/api/turnover';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IBaseApiListResponse, IListParams, ITurnoverApiListResponse, ITurnoverEventApiListResponse, ITurnoverFilters } from '@/types';

export const turnoverService = {
    async selection(params: IListParams<ITurnoverFilters>): Promise<AxiosResponse<ITurnoverApiListResponse>> {
        try {
            const response = await baseListService<ITurnoverApiListResponse>(selection, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            throw new AppError(`Unable load selection list, request error`, { cause: e });
        } finally {
        }
    },

    async selectionDetail(params: IListParams<ITurnoverFilters>): Promise<AxiosResponse<IBaseApiListResponse>> {
        try {
            const response = await baseListService<IBaseApiListResponse>(selectionDetail, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            throw new AppError(`Unable load selection detail, request error`, { cause: e });
        } finally {
        }
    },

    async event(params: IListParams<ITurnoverFilters>): Promise<AxiosResponse<ITurnoverEventApiListResponse>> {
        try {
            const response = await baseListService<ITurnoverEventApiListResponse>(game, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            throw new AppError(`Unable load game list, request error`, { cause: e });
        } finally {
        }
    },

    async gameDetail(params: IListParams<ITurnoverFilters>): Promise<AxiosResponse<IBaseApiListResponse>> {
        try {
            const response = await baseListService<IBaseApiListResponse>(gameDetail, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            throw new AppError(`Unable load game detail, request error`, { cause: e });
        } finally {
        }
    },
};
